import { render, staticRenderFns } from "./SystemSetup.vue?vue&type=template&id=d66da58c"
import script from "./SystemSetup.vue?vue&type=script&lang=js"
export * from "./SystemSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports